module.exports = __webpack_public_path__ + "static/img/img12.674d23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img12.png
// module id = yxVF
// module chunks = 1